import { useMemo } from "react";

import type { CSSProperties } from "react";

export function useResponsiveImageStyle(width: number, height: number): CSSProperties {
  return useMemo(() => {
    const aspect = height / width;
    const maxHeight = Math.min(window.innerHeight - 300, 700);
    const imageWidth = width * aspect > maxHeight ? maxHeight / aspect : width;

    return {
      paddingTop: `${aspect * 100}%`,
      width: `${imageWidth}px`,
    };
  }, [width, height]);
}
